import React, { useState } from "react";
import axios from "axios";


// Skeleton Loader
const SkeletonLoader = () => (
  <div className="animate-pulse space-y-4">
    <div className="h-10 bg-gray-300 rounded"></div>
    <div className="h-10 bg-gray-300 rounded"></div>
    <div className="h-10 bg-gray-300 rounded"></div>
    <div className="h-24 bg-gray-300 rounded"></div>
    <div className="h-12 bg-gray-300 rounded w-full"></div>
  </div>
);

const Contact = () => {
  const [form, setForm] = useState({
    name: "",
    mobile: "",
    email: "",
    note: "",
  });
  const [submitting, setSubmitting] = useState(false);
  const [response, setResponse] = useState(null);
  const [error, setError] = useState("");

  const onFormChange = (e) => {
    const { name, value } = e.target;
    if (name === "name" && !/^[A-Za-z\s]*$/.test(value)) return;
    if (name === "mobile" && !/^[0-9]{0,10}$/.test(value)) return;

    setForm({ ...form, [name]: value });
  };

  const validateFields = () => {
    const { name, mobile, email } = form;
    const nameRegex = /^[A-Za-z\s]+$/;
    const phoneRegex = /^[0-9]{10}$/;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!name.trim() || !mobile.trim() || !email.trim()) {
      setError("Please fill in all required fields.");
      return false;
    }
    if (!nameRegex.test(name)) {
      setError("Name should contain only letters.");
      return false;
    }
    if (!phoneRegex.test(mobile)) {
      setError("Mobile number must be exactly 10 digits.");
      return false;
    }
    if (!emailRegex.test(email)) {
      setError("Invalid email format.");
      return false;
    }
    return true;
  };

  const submitForm = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setResponse(null);
    setError("");

    if (!validateFields()) {
      setSubmitting(false);
      return;
    }

    try {
      const res = await axios.post(
        `https://czuhbymjw8.execute-api.us-east-1.amazonaws.com/dev/send-email`,
        form,
        { headers: { "Content-Type": "application/json" } }
      );

      if (res.status === 200) {
        setResponse({ type: "success", msg: "Your request has been submitted!" });
        setForm({
          name: "",
          mobile: "",
          email: "",
          note: "",
        });
      } else {
        throw new Error(res.data?.message || "Failed to send");
      }
    } catch (err) {
      console.error("Axios submission error:", err);
      setResponse({
        type: "error",
        msg: "Failed to send message. Please try again.",
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <div className="">
        <div
          className="w-full flex justify-center items-center text-white font-bold px-4 bg-cover bg-center min-h-[220px] md:min-h-[280px] py-10 md:py-16"
          style={{ backgroundImage: `url(/banner.png)` }}
        >
          <div className="text-center max-w-[95%] sm:max-w-[80%] md:max-w-[60%] px-2">
            <h1 className="text-brand-green text-2xl sm:text-3xl md:text-7xl leading-snug sm:leading-normal">
              Contact Us
            </h1>
          </div>
        </div>

        {/* Main content */}
        <div className="max-w-6xl mx-auto flex flex-wrap justify-between gap-8 p-5">
          {/* Form Section */}
          <div className="flex-1 min-w-[280px] max-w-md w-full">
            <h2 className="text-3xl md:text-4xl font-bold mb-6 text-left md:text-left text-brand-green">
              Ready To Go Solar? Contact Us Today!
            </h2>

            {submitting ? (
              <SkeletonLoader />
            ) : (
              <section className="bg-white rounded-2xl shadow-xl p-6 md:p-8">
                <form onSubmit={submitForm} className="space-y-4 max-w-2xl mx-auto">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <label className="block text-xs text-gray-600 mb-1">Name*</label>
                      <input
                        name="name"
                        value={form.name}
                        onChange={onFormChange}
                        className="w-full border rounded-lg px-3 py-2 text-base focus:outline-none focus:ring-2"
                        style={{ borderColor: "#216700" }}
                        placeholder="Your full name"
                        required
                      />
                    </div>
                    <div>
                      <label className="block text-xs text-gray-600 mb-1">Mobile*</label>
                      <input
                        name="mobile"
                        value={form.mobile}
                        onChange={onFormChange}
                        className="w-full border rounded-lg px-3 py-2 text-base focus:outline-none focus:ring-2"
                        style={{ borderColor: "#216700" }}
                        placeholder="+91 9xxxxxxxxx"
                        required
                      />
                    </div>
                    <div className="md:col-span-2">
                      <label className="block text-xs text-gray-600 mb-1">Email*</label>
                      <input
                        name="email"
                        type="email"
                        value={form.email}
                        onChange={onFormChange}
                        className="w-full border rounded-lg px-3 py-2 text-base focus:outline-none focus:ring-2"
                        style={{ borderColor: "#216700" }}
                        placeholder="you@example.com"
                        required
                      />
                    </div>
                  </div>

                  <div>
                    <label className="block text-xs text-gray-600 mb-1">Note</label>
                    <textarea
                      name="note"
                      value={form.note}
                      onChange={onFormChange}
                      rows={3}
                      className="w-full border rounded-lg px-3 py-2 text-base focus:outline-none focus:ring-2"
                      style={{ borderColor: "#216700" }}
                      placeholder="Site address, roof area, expected load, timeline…"
                    />
                  </div>

                  <div className="flex items-center justify-center gap-3 pt-1">
                    <button
                      type="submit"
                      disabled={submitting}
                      className="px-8 py-2 rounded-lg text-white hover:opacity-90 disabled:opacity-60 bg-brand-green"
                    >
                      {submitting ? "Submitting…" : "Submit"}
                    </button>
                  </div>

                  <p className="text-xs text-gray-500 pt-2">
                    By submitting, you agree to be contacted about your request. We respect your privacy.
                  </p>

                  {error && (
                    <div className="mt-2 px-4 py-2 rounded bg-red-100 text-red-800">{error}</div>
                  )}
                  {response && (
                    <div
                      className={`mt-2 px-4 py-2 rounded ${response.type === "success"
                          ? "bg-green-100 text-[#216700]"
                          : "bg-red-100 text-red-800"
                        }`}
                    >
                      {response.msg}
                    </div>
                  )}
                </form>

              </section>
            )}
          </div>

          {/* Image Section */}
          <div className="flex-1 max-w-xl md:block hidden text-center">
            <img src="/solar-worker.svg" alt="Solar Installation" />
          </div>
        </div>
      </div>
    </>
  );
};

export default Contact;
